export const MODULE_NAMESPACE = "userAuthentication";
